import React, { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/admin/session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.bridgeToken) {
        throw new Error(data.error || 'Onjuist wachtwoord');
      }

      localStorage.setItem('hitster-admin', 'true');
      localStorage.setItem('hitster-admin-bridge', data.bridgeToken);
      navigate('/admin-home');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Onjuist wachtwoord');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h1>Admin inloggen</h1>
        <p className="admin-login-sub">Alleen voor beheerders van Ouderwetse Gezelligheid.</p>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <label htmlFor="password">Wachtwoord</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
            autoComplete="current-password"
          />
          {error && <p className="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading}>{loading ? 'Bezig...' : 'Inloggen'}</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
